import { styles } from 'studio/components/MarkdownHtml/MarkdownHtml.styles';
import { alpha } from '@mui/material/styles';
import { spacing } from 'studio/helpers';

function fileActionBar(theme) {
  return {
    zIndex: 9,
    position: 'relative',
    height: 41,
    display: 'flex',
    borderLeft: 0,
    borderRight: 0,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.divider,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  };
}

// the prefix of the glyph margin CSS class name of synchronize decorations
export const synchronizeGlyphMarginClassNamePrefix = 'synchronize-';

export default theme => ({
  disabled: {
    color: 'lightgray'
  },
  fileicon: {
    height: 14,
    opacity: 0.8
  },
  main: {
    width: '100%',
    paddingLeft: theme.drawerWidth,
    marginLeft: -theme.drawerWidth
  },
  editor: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& .markdown-docs > div > *:first-child': {
      marginBlockStart: 0
    },
    '& .markdown-docs h1': {
      fontSize: 14,
      fontWeight: 400
    },
    '& .markdown-docs': {
      // get the styles from the 'MarkdownHtml' component and mark all CSS
      // values as '!important' to override the default styles from Monaco
      ...Object.fromEntries(
        Object.entries(styles(theme)).map(([key, value]) => [
          key,
          Object.fromEntries(Object.entries(value).map(([key, value]) => [key, `${value} !important`]))
        ])
      )
    },
    [`& *[class*='${synchronizeGlyphMarginClassNamePrefix}']`]: {
      '&:after': {
        color: theme.palette.text.secondary,
        fontFamily: 'Material Icons',
        fontSize: 15,
        content: '"sync"',
        cursor: 'pointer',
        padding: '0 1.5px',
        borderRadius: '50%',
        marginLeft: 2
      },
      '&:hover:after': {
        backgroundColor: alpha(theme.palette.common[theme.isDark ? 'white' : 'black'], 0.06)
      }
    },
    "& .monaco-editor-hover[widgetid='editor.contrib.modesGlyphHoverWidget']": {
      marginLeft: 10,
      paddingLeft: 12,
      paddingRight: 12,
      paddingTop: 6,
      paddingBottom: 6,
      fontSize: 12,
      fontWeight: 500,
      border: 'none',
      borderRadius: 4,
      backgroundColor: 'rgba(97, 97, 97, 0.9)',
      color: theme.palette.common.white
    }
  },
  filebar: {
    marginTop: 48,
    '& .MuiTabs-root': {
      minHeight: 30,
      backgroundColor: theme.tabs.backgroundColor
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      alignItems: 'center',
      flexDirection: 'row',
      fontSize: 12,
      padding: '6px 12px',
      minWidth: 'auto',
      maxWidth: 'none',
      minHeight: 30,
      borderRight: theme.tab.border,
      backgroundColor: theme.tab.backgroundColor,
      '&:first-child': {
        borderLeft: theme.tab.border
      },
      '&.Mui-selected': {
        backgroundColor: theme.tab.selected.backgroundColor
      },
      '& > span': {
        marginTop: 2
      }
    },
    '& .MuiTab-root .MuiSvgIcon-root': {
      width: theme.spacing(3),
      height: theme.spacing(3),
      padding: theme.spacing(0.5),
      marginLeft: -spacing(theme, 0.5),
      marginRight: theme.spacing(0.5),
      position: 'relative',
      top: 1
    },
    '& .MuiTab-root .MuiSvgIcon-root:last-of-type': {
      marginLeft: theme.spacing(0.5),
      marginRight: -spacing(theme, 0.5)
    }
  },
  fileTooltip: {
    maxWidth: 'none'
  },
  editorActionBar: {
    display: 'flex',
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.divider,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.divider,
    paddingLeft: theme.spacing(1)
  },
  treeTypeToggle: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '& .MuiToggleButton-root': {
      padding: theme.spacing(0.5)
    },
    '& .MuiSvgIcon-root': {
      height: 20
    }
  },
  fileActionBar: fileActionBar(theme),
  unmanagedWarningBar: {
    ...fileActionBar(theme),
    backgroundColor: theme.warningColor,
    display: 'flex',
    alignItems: 'center',
    height: '31px'
  },
  actionButton: {
    maxWidth: theme.spacing(5),
    maxHeight: theme.spacing(5),
    minWidth: theme.spacing(5),
    minHeight: theme.spacing(5)
  },
  actionButtonWithText: {
    border: 'none !important'
  },
  actionLink: {
    color: theme.actionLinkColor
  },
  createFileDialog: {
    '& .MuiDialogContent-root': {
      height: 150
    }
  },
  deleteEntitiesCheckbox: {
    marginBottom: theme.spacing(1)
  },
  modalFilePathListElement: {
    listStyleType: 'none',
    padding: '4px 10px',
    backgroundColor: '#eeeeee',
    maxHeight: 200,
    overflow: 'auto',
    fontSize: 12,
    lineHeight: '20px',
    borderRadius: 2
  },
  editorContainer: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden'
  },
  monacoContainer: {
    flex: 1,
    overflow: 'hidden'
  },
  treeContainer: {
    flex: 1,
    overflow: 'auto',
    '& .MuiTreeView-root:first-child': {
      borderTopWidth: theme.spacing(1),
      borderTopStyle: 'solid',
      borderTopColor: theme.palette.background.paper
    }
  }
});
